import * as React from "react";
import { Button, Typography, Box, Grid, Divider, useMediaQuery, Dialog, DialogContent, Link } from "@mui/material";
import { useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import NumberFormat from "react-number-format";
import { getAutoPays } from "../../resui/payments/sagas/residentpaymentsSlice";
import { TieredPricingTable } from "../../pmui/onboarding/pricingCard";
import { AmountTier, PaidByEnum } from "@inosio/payments-sdk";

const useStyles = makeStyles({
  modalContainer: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderRadius: "24px",
  },
  detailsMainItem: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #9999",
    color: "#222",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    margin: "0 auto",
  },
  detailsMinorItem: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #9999",
    color: "#999",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    margin: "0 auto",
  },
  detailsTotal: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "3px solid #222222",
    borderBottom: "3px solid #222222",
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#14142B",
    marginTop: "5px",
    marginBottom: "5px",
    margin: "0 auto",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "0 auto",
    marginTop: "30px",
  },
  reviewAndSubmitMainDetails: {
    marginBottom: "18px",
  },
  termsAndConditionLink: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#39A2DB !important",
    marginTop: "18px",
    cursor: "pointer",
  },
});

interface RecurringThankYouModalProps {
  openStateThankYou: boolean;
  closeCallbackThankYou: () => void;
  totalAmount: number;
  transactionDate: string;
  paidAmount: number;
  paymentFees: number;
  pmCompany: string;
  propertyName: string;
  leaseHolderName: string;
  last4: string;
  selectedPaymentMethodTiers?: AmountTier[];
  transactionDateShort: string;
  type?: string;
  header?: string;
}

export default function RecurringThankYouModal(props: RecurringThankYouModalProps) {
  const classes = useStyles();
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");
  const dispatch = useDispatch();

  const [showTieredPricingTable, setShowTieredPricingTable] = React.useState(false);

  const handleClose = () => {
    props.closeCallbackThankYou();
    dispatch(getAutoPays());
  }

  return (
    <div className={classes.modalContainer}>
      <Dialog 
        fullScreen={isOnMobileScreen} 
        open={props.openStateThankYou} 
        onClose={handleClose} 
        hideBackdrop={true} 
        PaperProps={{
          style: {
            pointerEvents: "auto",
            borderRadius: "24px",
            height: isOnMobileScreen ? "" : "700px",
          },
        }}
        >
        <DialogContent>
          <Box>
            <div id="simple-modal-title">
              <Typography id="payment-details-title" style={{ marginBottom: "40px" }} variant="h6" component="h2">
                Thank you for setting up an autopayment.
              </Typography>
            </div>
            <div>
              <Typography
                style={{
                  borderRadius: "24px",
                  background: "#F1F0F5",
                  height: "90px",
                  width: "100%",
                  padding: "10px 15px",
                  margin: "10px 0px",
                  marginBottom: "25px",
                }}
              >
                {props.header}
              </Typography>
            </div>
            <Box sx={{ width: "100%" }}>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} position={"relative"}>
                {showTieredPricingTable && (
                  <Box sx={{ width: "230px", height: "max-content", position: "absolute", top: "20%", right: "2%", zIndex: "9", background: "#ffffff", border: "2px solid #eeeeee", borderRadius: "5px" }}>
                    <TieredPricingTable tiers={props.selectedPaymentMethodTiers ?? []} />
                  </Box>
                )}
                <Grid item xs={6}>
                  <div>
                    <Typography
                      style={{
                        color: "#14142B",
                        fontSize: "16px",
                      }}
                      id="review-submit-main-details"
                    >
                      {props.pmCompany ? `${props.pmCompany.slice(0, 20)}...` : ""}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography
                      style={{
                        color: "#14142B",
                        fontSize: "16px",
                      }}
                      id="review-submit-main-details"
                    >
                      {props.propertyName ? `${props.propertyName.slice(0, 13)}...` : ""}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.reviewAndSubmitMainDetails}>
                    <Typography
                      style={{
                        color: "#14142B",
                        fontSize: "16px",
                      }}
                      id="review-submit-main-details"
                    >
                      {props.leaseHolderName}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.reviewAndSubmitMainDetails}>
                    <Typography
                      style={{
                        color: "#14142B",
                        fontSize: "16px",
                      }}
                      id="review-submit-main-details"
                    >
                      {" "}
                      {/* TODO: add unit when available */}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Divider />
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ marginTop: "5px" }}>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-bank-details-text"> Payment Method</Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-bank-details">{props.last4}</Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">Amount</Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">
                      {props.type === "full" ? (
                        " My Full Balance   "
                      ) : (
                        <NumberFormat thousandsGroupStyle="thousand" value={props.paidAmount} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                      )}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">Fee Amount</Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">
                      {props.type === "full" && props.selectedPaymentMethodTiers && props.selectedPaymentMethodTiers.some((tier: AmountTier) => tier.PaidBy === PaidByEnum.Payer) ? (
                        <Link
                          className={classes.termsAndConditionLink}
                          onMouseEnter={(event: React.SyntheticEvent) => {
                            setShowTieredPricingTable(true);
                          }}
                          onMouseLeave={(event: React.SyntheticEvent) => {
                            setShowTieredPricingTable(false);
                          }}
                        >
                          Fee
                        </Link>
                      ) : (
                        <NumberFormat thousandsGroupStyle="thousand" value={props.paymentFees} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                      )}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">Total Amount</Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">
                      {props.type === "full" ? (
                        <>My Full Balance</>
                      ) : (
                        <NumberFormat thousandsGroupStyle="thousand" value={props.totalAmount} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                      )}

                      {props.selectedPaymentMethodTiers && props.selectedPaymentMethodTiers.some((tier: AmountTier) => tier.PaidBy === PaidByEnum.Payer) ? (
                        <>
                          {" "}
                          +
                          <Link
                            className={classes.termsAndConditionLink}
                            onMouseEnter={(event: React.SyntheticEvent) => {
                              setShowTieredPricingTable(true);
                            }}
                            onMouseLeave={(event: React.SyntheticEvent) => {
                              setShowTieredPricingTable(false);
                            }}
                          >
                            Fee
                          </Link>
                        </>
                      ) : (
                        <></>
                      )}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">Transaction Date</Typography>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <Typography id="review-submit-sub-details">{props.transactionDateShort}</Typography>
                  </div>
                </Grid>
              </Grid>
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="error"
                  id="request-fund"
                  style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontStyle: "normal",
                    fontWeight: 700,
                  }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  id="done"
                  style={{
                    fontFamily: "'Open Sans', sans-serif",
                    fontStyle: "normal",
                    fontWeight: 700,
                    width: "99px",
                  }}
                  onClick={handleClose}
                >
                  Done
                </Button>
              </div>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
}
